import LOGO from "../images/roadrunner.png";

export const Team__RoadRunner = {
  name: "Road Runners",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#c8e7f3ff",
  teamJerseyColor: "#0E293D",

  // Stats
  gamesWon: 0,
  gamesLost: 3,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 0,
  goalsScoredAgainst: 29 + 48 + 49,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [
    {
      goalsScored: 27 + 34 + 20,
    },
  ],
};
